<template>
  <div>
    <div class="flex">
      <ToastAlert
        :is-active="toastAlert"
        :type="typeMsg"
        :message="msg"
      />
    </div>
    <div class="sm:w-[760px]">
      <!-- Gallery Section -->
      <div class="mb-8">
        <h3 class="text-lg font-medium text-gray-900 mb-4">Media</h3>
        <FormGalleryComponent 
          ref="formGalleryRef"
          :property-id="props.propertyId" 
          @trigger-update="handleGalleryUpdate"
        />
      </div>

      <!-- Video Section -->
      <div class="sm:mb-8 mb-16">
        <FormVideoComponent
          ref="formVideoRef"
          :property-id="props.propertyId" 
          @trigger-update="handleVideoUpdate"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import FormGalleryComponent from "@/components/properties/FormGalleryComponent.vue";
import FormVideoComponent from "@/components/properties/FormVideoComponent.vue";
import ToastAlert from "@/commond/ToastAlert.vue";

const props = defineProps({
  propertyId: {
    type: Number,
    required: true,
    default: 0
  }
});

// Definir los emits
const emit = defineEmits(['triggerUpdate']);

// Ref para el componente de galería
const formGalleryRef = ref(null);
// Ref para el componente de video
const formVideoRef = ref(null);

let toastAlert = ref(false);
let typeMsg = ref("");
let msg = ref("");

// Función para manejar actualizaciones de la galería
function handleGalleryUpdate(propertyId = null) {
  //console.log('Gallery updated, triggering parent update...', propertyId || props.propertyId);
  emit('triggerUpdate', propertyId || props.propertyId);
}

// Función para manejar actualizaciones del video
function handleVideoUpdate(propertyId = null) {
  //console.log('Video updated, triggering parent update...', propertyId || props.propertyId);
  emit('triggerUpdate', propertyId || props.propertyId);
}

// Función save para la compatibilidad con el componente padre
async function save() {
  // Validar que haya al menos una imagen (nueva o guardada)
  //const hasNewImages = formGalleryRef.value?.files?.length > 0;
  const hasSavedImages = formGalleryRef.value?.gallery?.length > 0;
  
  if (!hasSavedImages) {
    showToast("warning", "Debes subir al menos 3 imágenes para poder continuar.");
    return false; // No permitir avanzar sin imágenes
  }
  
  // Verificar si el componente de video tiene la referencia
  if (formVideoRef.value && typeof formVideoRef.value.saveVideoUrl === 'function') {
    // Si el input de videoUrl está vacío, permitir avanzar
    if (!formVideoRef.value.videoUrl || formVideoRef.value.videoUrl.trim() === '') {
      return true;
    }
    // Si hay contenido, ejecutar saveVideoUrl y retornar su resultado
    return await formVideoRef.value.saveVideoUrl();
  }
  // Si no hay referencia, permitir avanzar
  return true;
}

async function showToast(type, message) {
  toastAlert.value = true;
  typeMsg.value = type;
  msg.value = message;

  setTimeout(() => {
    closeToast();
  }, 3000);
}

async function closeToast() {
  toastAlert.value = false;
  typeMsg.value = "";
  msg.value = "";
}

// Exponer el método save para que pueda ser llamado desde el componente padre
defineExpose({
  save
});
</script>

<style scoped>
/* Component styles if needed */
</style>
